const BKTravel = {
    pageID: '4',
    title: 'มัดรวมจุดชมวิว กรุงเทพ สายถ่ายรูปห้ามพลาด',
    prevDescription: 'อย่ามัวแต่ตามหาที่ต่างจังหวัด กรุงเทพเองก็มีที่สวยๆวิวดีๆให้เราไปตามดูกันได้เหมือนกัน คลิก 1 ปึ๊งง! แล้วตามกันมาได้เลยย',
    topicDescription: 'นอกจากต่างจังหวัดแล้วกรุงเทพเองก็เป็นอีกหนึ่งจังหวัดที่มีอะไรให้ทำและเที่ยวอย่างมากมาย วันนี้เลยเอาสถานที่ท่องเที่ยวในกรุงเทพพร้อมวิวสวยๆมาฝาก ถ้าใครได้ตามไปชมรับรองไม่ผิดหวังแน่นอน และถ้าใครตามกันไปแล้วก็อย่าลืมอัพรูปสวยๆอวดกันด้วยน๊าา',
    previewImg: 'https://cms.dmpcdn.com/travel/2024/06/17/1a21e870-2c8f-11ef-b92b-356fcec2b93d_webp_original.webp',

    data: [
        {
            id: 1,
            title: 'มหานคร สกายวอล์ค',
            description: 'เตรียมชุดสวยๆ พร้อมกล้องถ่ายรูป ของทุกคนกันให้พร้อม! แล้วตามมาปักหมุดที่ จุดชมวิวกรุงเทพฯ สวยๆ  ของกรุงเทพ ที่ มหานคร สกายวอล์ค (Mahanakhon Skywalk) บนชั้น 78 ของ ตึก คิง เพาเวอร์ มหานคร',
            src: 'https://res.klook.com/images/fl_lossy.progressive,q_65/c_fill,w_3000,h_2002,f_auto/w_80,x_15,y_15,g_south_west,l_Klook_water_br_trans_yhcmh3/activities/mokwojnzcecbhqvcqmgi/%E0%B8%9A%E0%B8%B1%E0%B8%95%E0%B8%A3%E0%B9%80%E0%B8%82%E0%B9%89%E0%B8%B2%E0%B8%8A%E0%B8%A1%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%99%E0%B8%84%E0%B8%A3%E0%B8%AA%E0%B8%81%E0%B8%B2%E0%B8%A2%E0%B8%A7%E0%B8%AD%E0%B8%A5%E0%B9%8C%E0%B8%84(MahanakhonSkyWalk)%E0%B9%83%E0%B8%99%E0%B8%81%E0%B8%A3%E0%B8%B8%E0%B8%87%E0%B9%80%E0%B8%97%E0%B8%9E%E0%B8%AF-Klook%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%97%E0%B8%A8%E0%B9%84%E0%B8%97%E0%B8%A2.jpg',
        },
        {
            id: 2,
            title: 'ภูเขาทอง',
            description: 'ภูเขาทอง หรือ  พระบรมบรรพต เป็นเจดีย์บนภูเขาจำลองนับว่าเป็นแลนด์มาร์คของเกาะรัตนโกสินทร์ใจกลางกรุงเทพฯเลยทีเดียว ที่นี่ตั้งอยู่ที่วัดสระเกศราชวรมหาวิหารสร้างขึ้นในสมัยรัชกาลที่ 3 อีกทั้งด้านบนของภูเขาทองเป็นจุดชมวิวที่เราจะสามารถมองเห็นกรุงเทพฯได้แบบ 360 องศาอีกด้วย',
            src: 'https://cms.dmpcdn.com/travel/2022/10/20/b3f717b0-5034-11ed-acad-e91f3ac695b2_webp_original.jpg',
        },
        {
            id: 3,
            title: 'จุดชมวิวตึกใบหยกสกาย',
            description: 'จุดชมวิวกรุงเทพฯ สวยๆ ตอนพระอาทิตย์ตก อีกแห่งที่ห้ามพลาดเลยก็คือ จุดชมวิวตึกใบหยกสกาย ซึ่งตั้งอยู่ที่ชั้น 84 ของ โรงแรมใบหยกสกาย (Baiyoke Sky Hotel) นั่นเอง',
            src: 'https://tatapi.tourismthailand.org/tatfs/Image/CustomPOI/Picture/P03013834_1.jpeg',
        },
        {
            id: 4,
            title: 'สวนลอยฟ้าเจ้าพระยา',
            description: 'สวนลอยฟ้าเจ้าพระยา จุดชมวิวสวยๆในกรุงเทพฯที่ให้เราได้ไปนั่งชิลชมวิวแม่น้ำเจ้าพระยาที่จัดว่าดีงามมากๆ มานั่งรับลมในบรรยากาศสบายๆตั้งอยู่ที่กลางสะพานพระปกเกล้า ตรงนี้เป็นเหมือนสวนสาธารณะเล็กๆ มีต้นไม้ ดอกไม้ให้ได้พักผ่อนหย่อนใจอีกด้วย',
            src: 'https://cms.dmpcdn.com/travel/2023/09/17/940fe2f0-5539-11ee-94fb-d10c0ebeeb49_webp_original.webp',
        },
        {
            id: 5,
            title: 'ไอคอนสยาม',
            description: 'ปิดท้ายที่ ไอคอนสยาม (ICONSIAM) ที่เที่ยวกรุงเทพฯริมแม่น้ำเจ้าพระยาที่ชิลเอาท์บรรยากาศดีเต็มไปด้วย ร้านค้า ร้านอาหาร และที่สำคัญ ยังมีโซน River Park ที่มีน้ำพุเต้นระบำประกอบแสงสีเสียง ต้นไม้ ดอกไม้สวยๆ เหมือนสวนสาธารณะขนาดย่อมที่เราสามารถชมวิวสวยๆของแม่น้ำเจ้าพระยาได้',
            src: 'https://static.cdntap.com/tap-assets-prod/wp-content/uploads/sites/25/2022/04/Icon-Siam-Restaurant-1.jpg',
        },
    ]
}

export default BKTravel